import { Injectable } from '@angular/core';

export class RegularExpressions {
  // Regular Expression pattern cap
  public static readonly capPattern: RegExp = /^[+0-9]{5}$/;
  // Regular Expression pattern email
  //public static readonly emailPattern: RegExp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  public static readonly emailPattern: RegExp = /^[A-z0-9\.\+_-]+@[A-z0-9\._-]+\.[A-z]{2,6}$/;
  // Regular Expression pec o codice sdi
  public static readonly pecSdiPattern = /(^.{1,7}$|^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$)/;
  // Regular Expression pattern codice fiscale
  public static readonly cfPattern: RegExp = /(^[A-Z]{6}[\d+]{2}[ABCDEHLMPRST]{1}[\d+]{2}([A-Z]{1}[\d+]{3})[A-Z]{1}$|^[\d+]{11}$)/;
  // Regular Expression pattern codice IBAN
  public static readonly ibanPattern: RegExp = /^([A-Za-z]{2}[\-]?[0-9]{2})(?=(?:[\-]?[A-Z0-9a-z]){9,30}$)((?:[\-]?[A-Z0-9a-z]{3,5}){2,7})([\-]?[A-Z0-9]{1,3})?$/;
}

/**
 * Navigation targets for services portal
 */
export enum NavigationTarget {
  LOGOUT = '/auth/logout',
  LOGIN = '/auth',
  CHANGE_PWD = '/auth/modifica-password',
  SELFNET = '/selfnet',
  OVERVIEW = '/overview',
}
